"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createI18nApi = void 0;
const createI18nApi_1 = require("./createI18nApi");
const useLang_spa_1 = require("./useLang_spa");
exports.createI18nApi = (0, createI18nApi_1.createI18nApiFactory)({
    createUseLang: useLang_spa_1.createUseLang,
}).createI18nApi;
